import React, { useState, useEffect } from "react";
import { Table, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import DOMPurify from 'dompurify'; // Library untuk sanitasi input HTML
import validator from 'validator'; // Library untuk validasi URL
import './AkreditasiKampus.css';

const akreditasiData = [
    { program: "UPI YPTK", jenjang: "Universitas", tahun: "2022 - 2027", link: "/Akreditasi/Sertifikat-AIPT-2022.pdf" },
    { program: "UPI YPTK (Legalisisir BAN-PT)", jenjang: "Universitas", tahun: "2017 - 2022", link: "/Akreditasi/Sertifikat-AIPT Legalisir.jpg" },
    { program: "UPI YPTK (Lamemba)", jenjang: "Universitas", tahun: "2022 - 2027", link: "/Akreditasi/Sertifikat-Akreditasi-LAMEMBA-Universitas-Putra-Indonesia-YPTK-Sarjana-Akuntansi-2023.pdf" },
    { program: "UPI YPTK", jenjang: "Universitas", tahun: "2017 - 2022", link: "/Akreditasi/Sertifikat-AIPT.jpg" },
    { program: "UPI YPTK (BAN-PT)", jenjang: "Universitas", tahun: "2022 - 2027", link: "/Akreditasi/Sertifikat-AIPT-2022.pdf" },

    { program: "Akuntansi", jenjang: "D3", tahun: "2002", link: "/Akreditasi/d3-akuntansi-2002.pdf" },
    { program: "Akuntansi", jenjang: "S1", tahun: "2006", link: "/Akreditasi/AKUNTANSI-2006.jpeg" },
    { program: "Akuntansi", jenjang: "S1", tahun: "2012 - 2017", link: "/Akreditasi/AKUNTANSI-2012.jpeg" },
    { program: "Akuntansi", jenjang: "S1", tahun: "2017 - 2022", link: "/Akreditasi/Sertifikat BAN-PT Prodi S1-Akuntansi.png" },
    { program: "Akuntansi (Lamemba)", jenjang: "S1", tahun: "2022 - 2027", link: "/Akreditasi/Sertifikat-Akreditasi-LAMEMBA-Universitas-Putra-Indonesia-YPTK-Sarjana-Akuntansi-2023.pdf" },

    { program: "Manajemen", jenjang: "S1", tahun: "2006-2011", link: "/Akreditasi/MANAJEMEN-2006.jpeg" },
    { program: "Manajemen", jenjang: "S1", tahun: "2011-2016", link: "/Akreditasi/MANAJEMEN-2011.jpeg" },
    { program: "Manajemen", jenjang: "S1", tahun: "2016-2021", link: "/Akreditasi/Sertifikat BAN-PT Manajemen.jpg" },
    { program: "Manajemen", jenjang: "S1", tahun: "2021-2026", link: "/Akreditasi/S1-Manajemen-2021-2026.pdf" },

    { program: "Manajemen Informatika", jenjang: "D3", tahun: "2011 - 2016", link: "/Akreditasi/SERTIFIKAT-AKREDITASI-MI-2011.pdf" },
    { program: "Manajemen Informatika", jenjang: "D3", tahun: "2016 - 2021", link: "/Akreditasi/Sertifikat BAN-PT Prodi D3-Manajemen Informatika.jpeg" },

    { program: "Magister Komputer", jenjang: "S2", tahun: "2018 - 2023", link: "/Akreditasi/Sertifikat BAN-PT Prodi Magister Komputer-2018-2023.JPG" },

    { program: "Teknik Informatika", jenjang: "S1", tahun: "2011 - 2016", link: "/Akreditasi/all-TI-2011-2015.pdf" },
    { program: "Teknik Informatika", jenjang: "S1", tahun: "2016 - 2021", link: "/Akreditasi/SERTIFIKAT AKREDITAS IF 2016.pdf" },
    { program: "Teknik Informatika", jenjang: "S1", tahun: "2021 - 2026", link: "/Akreditasi/SERTIFIKAT AKREDITAS IF 2022.pdf" },

    { program: "Magister Teknik Informatika", jenjang: "S2", tahun: "2018 - 2023", link: "/Akreditasi/SERTIFIKAT AKREDITASI MKOM 2018.pdf" },

    { program: "Teknik Sipil", jenjang: "S1", tahun: "2021 - 2026", link: "/Akreditasi/Sertifikat-Akreditasi-Prodi-S1-Teknik-Sipil-2021-2026.pdf" },

    { program: "Desain Komunikasi Visual", jenjang: "S1", tahun: "2014 - 2019", link: "/Akreditasi/Sertifikat BAN-PT Prodi DKV.jpg" },
    { program: "Desain Komunikasi Visual", jenjang: "S1", tahun: "2019 - 2024", link: "/Akreditasi/Sertifikat BAN-PT Prodi DKV-2019-2024.jpeg" },

    { program: "Magister Manajemen", jenjang: "S2", tahun: "2014 - 2019", link: "/Akreditasi/Sertifikat BAN-PT Prodi Magister Manajemen.jpg" },

    { program: "Teknik Elektro", jenjang: "S1", tahun: "2019 - 2024", link: "/Akreditasi/SERTIFIKAT%20AKREDITASI%20TE%202019.pdf" },

    { program: "Teknik Sipil", jenjang: "S1", tahun: "2021-2026", link: "/Akreditasi/Sertifikat-Akreditasi-Prodi-S1-Teknik-Sipil-2021-2026.pdf" },

    { program: "Teknik Industri", jenjang: "S1", tahun: "2023", link: "/Akreditasi/SK-Akreditasi-Teknik-Industri-2023.pdf" },
    { program: "Teknik Industri (Lam Teknik)", jenjang: "S1", tahun: "2023", link: "/Akreditasi/Sertifikat-Akreditasi-Teknik-Industri-2023.pdf" },
    { program: "Teknik Industri (BAN-PT)", jenjang: "S1", tahun: "2018-2023", link: "/Akreditasi/Sertifikat BAN-PT Prodi Teknik Industri.png" },

    { program: "Psikologi", jenjang: "S1", tahun: "2015-2020", link: "/Akreditasi/Sertifikat BAN-PT Prodi S1-Psikologi.jpg" },
    { program: "Psikologi", jenjang: "S1", tahun: "2020-2025", link: "/Akreditasi/Sertifikat Akreditasi Psikologi 2020.pdf" }, 

    { program: "Sistem Informasi", jenjang: "S1", tahun: "2014 - 2019", link: "/Akreditasi/Sertifikat BAN-PT Prodi S1-Sistem Informasi.jpg" },
    { program: "Sistem Informasi", jenjang: "S1", tahun: "2019 - 2024", link: "/Akreditasi/Sertifikat BAN-PT Prodi S1-Sistem Informasi-2019-2024.jpg" },
    { program: "Sistem Informasi", jenjang: "S1", tahun: "2024 - 2029", link: "/Akreditasi/Sertifikat Akreditasi LAMINFOKOM Sistem Informasi 2024-2029.pdf" },

    { program: "Sistem Komputer", jenjang: "S1", tahun: "2016 - 2021", link: "/Akreditasi/Sertifikat BAN-PT Prodi S1-Sistem Komputer.jpg" },
    { program: "Sistem Komputer", jenjang: "S1", tahun: "2016 - 2021", link: "/Akreditasi/SERTIFIKAT AKREDITASI SK 2016.pdf" },
    { program: "Sistem Komputer", jenjang: "S1", tahun: "2021 - 2026", link: "/Akreditasi/Sertifikat Akreditasi Prodi Sistem Komputer 2021-2026.pdf" },

    { program: "Teknik Informatika", jenjang: "S1", tahun: "2018 - 2023", link: "/Akreditasi/Sertifikat BAN-PT Prodi S1-Teknik Informatika-2018-2023.jpg" },
    { program: "Teknik Informatika", jenjang: "S1", tahun: "2016 - 2021", link: "/Akreditasi/Sertifikat BAN-PT Prodi S1-Teknik Informatika.jpeg" },
];

  const AkreditasiKampus = () => {
    const [searchText, setSearchText] = useState("");
    const [selectedJenjang, setSelectedJenjang] = useState("All");
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    useEffect(() => {
        // Memastikan halaman tidak dimuat dalam iframe
        if (window.self !== window.top) {
          window.top.location = window.self.location;
        }
      }, []);

    const handleSearchChange = (e) => {
        const input = e.target.value;
        const sanitizedInput = DOMPurify.sanitize(input);
        
        if (/^[a-zA-Z0-9\s]+$/.test(sanitizedInput)) {
            setSearchText(sanitizedInput);
        } else {
            console.log('Input mengandung karakter tidak valid');
        }
    };
    

    const handleJenjangChange = (jenjang) => {
        setSelectedJenjang(jenjang);
    };

    // Sanitasi data awal
    const sanitizedData = akreditasiData.map(data => ({
        ...data,
        program: DOMPurify.sanitize(data.program),
        jenjang: DOMPurify.sanitize(data.jenjang),
        tahun: DOMPurify.sanitize(data.tahun)
    }));    

    // Filter data berdasarkan pencarian dan jenjang yang dipilih
    const filteredData = sanitizedData.filter((data) => {
        const matchesSearchText = data.program.toLowerCase().includes(searchText.toLowerCase());
        const matchesJenjang = selectedJenjang === "All" || data.jenjang === selectedJenjang;
        return matchesSearchText && matchesJenjang;
    });


    // Validasi URL untuk memastikan hanya tautan yang sah
    const isValidLink = (url) => {
        // Cek apakah link adalah path lokal yang aman
        if (url.startsWith("/Akreditasi/") && !url.includes("..")) {
            return true;
        }
    
        // Validasi URL penuh jika bukan path lokal
        return validator.isURL(url, { protocols: ['http', 'https'], require_tld: true });
    };
     

    return (
        <div className="akreditasi-kampus">
            {/* Header Section */}
            <header className="header-section">
                <div className="header-content">
                    <h2>Akreditasi UPI YPTK</h2>
                    <hr className="header-line" />
                </div>
            </header>

            <div className="container mt-4">
                {/* Filter Dropdown */}
                <div className="mb-3">
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                        <DropdownToggle caret color="primary" className="d-flex align-items-center">
                            {selectedJenjang}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => handleJenjangChange("All")}>All</DropdownItem>
                            <DropdownItem onClick={() => handleJenjangChange("Universitas")}>Universitas</DropdownItem>
                            <DropdownItem onClick={() => handleJenjangChange("D3")}>D3</DropdownItem>
                            <DropdownItem onClick={() => handleJenjangChange("S1")}>Sarjana / S1</DropdownItem>
                            <DropdownItem onClick={() => handleJenjangChange("S2")}>Magister / S2</DropdownItem>
                            <DropdownItem onClick={() => handleJenjangChange("S3")}>Doktor / S3</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>

                {/* Filter Cari Program */}
                <div className="mb-3">
                    <Input
                        type="text"
                        placeholder="Cari Program Studi..."
                        value={searchText}
                        onChange={handleSearchChange}
                        className="d-flex align-items-center"
                    />
                </div>

                {/* Tabel Data Akreditasi */}
                <Table striped>
                    <thead>
                        <tr>
                            <th className="text-center align-middle">No.</th>
                            <th className="align-middle">Program</th>
                            <th className="align-middle">Jenjang</th>
                            <th className="align-middle">Tahun</th>
                            <th className="text-center align-middle">Unduh</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((data, index) => (
                            <tr key={index}>
                                <td className="text-center align-middle">{index + 1}</td>
                                <td className="align-middle">{DOMPurify.sanitize(data.program)}</td> {/* Sanitasi data program */}
                                <td className="align-middle">{DOMPurify.sanitize(data.jenjang)}</td>
                                <td className="align-middle">{DOMPurify.sanitize(data.tahun)}</td>
                                <td className="text-center align-middle">
                                    {isValidLink(data.link) ? (
                                        <a 
                                            href={data.link} 
                                            className="btn btn-primary" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                        >
                                            Unduh
                                        </a>
                                    ) : (
                                        <span className="text-danger">Link tidak valid</span> 
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default AkreditasiKampus;